/* ============================================================
   MOSAIK — CORE
   Central state object + shared helpers. Every other module
   (render / recap / cart / controller / lights) attaches onto
   `window.mosaik` via Object.assign, so `this` always refers here.

   Load order (see the section .liquid):
     data -> geometry -> lights -> pdf -> core -> render
          -> recap -> cart -> controller
   ============================================================ */
window.mosaik = {
    options: {
        width:0,
        height:0,
        mosaikWidth:0.5,
        mosaikHeight:0.5,
        currentCollection:false,
        currentPile:false,
        currentBorder:false,
        currentCorner:false,
        editMode:'dalles',        // which element clicks paint: dalles | bordures | angles | gomme
        solid_pile:false,
        checkerboard_piles:[],
        checkerboard_counter:0,
        fill:'image'
    },
    grid:null,
    ctx:null,
    editable:false,
    paths:[],
    borderPaths:[],
    cornerPaths:[],
    result:[],
    borderAssignments:{},
    cornerAssignments:{},

    // Lights layer state (see mosaik-lights.js). Keyed by tile index.
    lightAssignments:{},
    lightPaths:[],

    // Latest geometry produced by render (reused by feature layers, e.g. lights)
    layout:null,

    /* --- data references (defined in mosaik-data.js) ---
       Relues à CHAQUE accès, et jamais figées au chargement de ce fichier : si
       mosaik-data.js manque, échoue ou arrive après (asset non déployé, 404,
       erreur de syntaxe), le configurateur dégrade au lieu d'exploser sur
       `this.l10n[...] is undefined` — une erreur qui, elle, ne dit rien du
       fichier fautif. mosaik-controller.js le signale nommément en console. */
    get collections(){ return window.MOSAIK_COLLECTIONS || {}; },
    get l10n(){ return window.MOSAIK_L10N || {}; },

    // --- shared helpers ---
    countBordersBySide : function(side, color) {
      return Object.values(this.borderAssignments)
               .filter(bo =>
                  bo.side === side &&
                  bo.color == color
                )
               .length;
    },
    getText:function(s){
        return((this.l10n || {})[this.options.lang] || {})[s] || s;
    },
    // Résout dès que l'image est prête. IMPORTANT : on résout aussi sur erreur
    // (image manquante / bloquée par CORS) et si l'image est déjà chargée, sinon
    // une seule image en échec bloque `draw()` indéfiniment et le canvas reste vide.
    waitImg:function(img){
      return new Promise(res=>{
        if(img.complete){ res(img.naturalWidth > 0); return; }
        img.addEventListener('load',  () => res(true),  { once:true });
        img.addEventListener('error', () => res(false), { once:true });
      });
    }
};
